import { motion } from "framer-motion";
import { LogOut, Feather } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export const AdminShell = ({ children, title, subtitle, actions }) => {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#080b16] text-amber-50 antialiased selection:bg-amber-400/30">
      {/* ambient layers */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute -left-40 top-[-10%] h-[420px] w-[420px] rounded-full bg-amber-500/10 blur-[120px]" />
        <div className="absolute right-[-10%] top-1/3 h-[380px] w-[380px] rounded-full bg-orange-600/10 blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(251,191,36,0.06)_1px,transparent_0)] [background-size:26px_26px]" />
      </div>

      <header className="sticky top-0 z-30 border-b border-amber-300/10 bg-[#080b16]/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
          <button
            data-testid="admin-brand"
            onClick={() => navigate("/admin")}
            className="flex items-center gap-2.5 transition-opacity hover:opacity-80"
          >
            <span className="grid h-9 w-9 place-items-center rounded-xl border border-amber-300/30 bg-amber-400/10">
              <Feather className="h-4 w-4 text-amber-300" />
            </span>
            <span className="text-left">
              <span className="block font-semibold tracking-tight text-amber-100">
                Take Krishna Home
              </span>
              <span className="block text-[10px] uppercase tracking-[0.3em] text-amber-300/60">
                Campaign Console
              </span>
            </span>
          </button>
          <div className="flex items-center gap-3">
            <span className="hidden text-xs text-amber-100/50 sm:inline">
              {admin?.email}
            </span>
            <button
              data-testid="admin-logout-btn"
              onClick={logout}
              className="inline-flex items-center gap-2 rounded-full border border-amber-300/20 px-3.5 py-1.5 text-xs font-medium text-amber-100/80 transition-all hover:border-amber-300/50 hover:bg-amber-400/10"
            >
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="relative z-10 mx-auto max-w-6xl px-5 pb-24 pt-10">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8 flex flex-wrap items-end justify-between gap-4"
        >
          <div>
            <h1 className="text-3xl font-semibold tracking-tight text-amber-50 sm:text-4xl">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-2 max-w-xl text-sm text-amber-100/50">{subtitle}</p>
            )}
          </div>
          {actions}
        </motion.div>
        {children}
      </main>
    </div>
  );
};
